<template>
  <el-container>
    <el-header height="80px">
      <div class="hmTp">
        <img src="../assets/shop.png" class="logo" />
        <span class="shopName">{{ info.name }}</span>
        <span class="balance">余额：{{ balance }}元</span>
      </div>
      <div class="info">
        <img src="../assets/user.gif" alt="" />
        <el-dropdown trigger="click" @command="exit">
          <p class="el-dropdown-link">
            <span>{{ info.linkname }}</span>
            <span>欢迎您</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </p>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <el-row class="tac">
          <el-col :span="12">
            <el-menu
              :default-active="this.$router.path"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
              router
            >
              <el-menu-item index="/carSeve">
                <i class="el-icon-menu"></i>
                <span slot="title">车辆优惠</span>
              </el-menu-item>
              <el-menu-item index="/shopDetail">
                <i class="el-icon-document"></i>
                <span slot="title">优惠明细</span>
              </el-menu-item>
              <el-menu-item index="/shopRechar">
                <i class="el-icon-bank-card"></i>
                <span slot="title">商户充值</span>
              </el-menu-item>
              <el-menu-item index="/topUpDetail">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">充值记录</span>
              </el-menu-item>
              <el-menu-item index="/danCode">
                <i class="el-icon-edit-outline"></i>
                <span slot="title">设置动态码</span>
              </el-menu-item>
              <el-menu-item index="/fixedCode" v-if="fixed">
                <i class="el-icon-full-screen"></i>
                <span slot="title">设置固定码</span>
              </el-menu-item>
              <el-menu-item index="/fixedList" v-if="fixed">
                <i class="el-icon-edit-outline"></i>
                <span slot="title">编辑固定码</span>
              </el-menu-item>
              <!-- <el-menu-item index="/editPswd" v-if="fixed">
                <i class="el-icon-edit-outline"></i>
                <span slot="title">修改登录密码</span>
              </el-menu-item> -->
            </el-menu>
          </el-col>
        </el-row>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-dialog
      title="新增券张数"
      :visible.sync="dialogVisible"
      width="25%"
      :before-close="handleClose"
    >
      <div class="compile">
        <p>旧密码：<el-input-number
            v-model="num"
            @change="handleChange"
            :min="1"
            :max="9999"
          ></el-input-number></p>
        <p>
          新密码：<el-input-number
            v-model="num"
            @change="handleChange"
            :min="1"
            :max="9999"
          ></el-input-number>
        </p>
        <p>
          确认新密码：<el-input-number
            v-model="num"
            @change="handleChange"
            :min="1"
            :max="9999"
          ></el-input-number>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
  
</template>

<script>
export default {
  data() {
    return {
      info: "",
      balance: 0,
      fixed: true,
    };
  },
  mounted() {
    this.info = JSON.parse(sessionStorage.getItem("shopData")).shop;
    this.fixed = this.info.isFixCode == 1 ? true : false;
    this.submitGetMessageList();
    this.balance = this.$store.state.balance;
    this.$axios.post("confirmOrder", data).then((res) => {
      // console.log(res)
      if (res.code == 0) {
        util.hint(res.code, "车辆优惠成功！");
        that.$store.dispatch("getMessageList");
      } else if (res.code == 400) {
        util.hint(res.code, res.msg);
      } else {
        util.hint("余额不足，请及时充值！", "none", 1500);
        return;
      }
      setTimeout(function () {
        that.$router.go(0);
      }, 2000);
    });
  },
  methods: {
    exit() {
      this.$router.push("/login");
      sessionStorage.removeItem("shopData");
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    submitGetMessageList() {
      const that = this;
      setTimeout(function () {
        that.$store.dispatch("getMessageList"); //$dispatch在vue2中已废除，此处用的是elementUI中的方法，触发actions
      }, 500);
    },
  },
  watch: {
    // watch 可以监听 data 数据 也可以监听 全局 vuex数据
    //监听vuex中userNumber的变化
    "$store.state.balance"(val) {
      this.balance = val;
    },
  },
};
</script>

<style lang="less" scoped>
.is-vertical {
  width: 100%;
  height: 100%;

  .el-header,
  .el-footer {
    background-color: #b3c0d1;
    color: #333;
  }

  .el-header {
    background-color: #f39b00;
    display: flex;

    .hmTp {
      position: relative;
      width: 3rem;
      height: 80px;

      .logo {
        width: 0.65rem;
        height: 0.65rem;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
      }

      .shopName {
        color: white;
        line-height: 40px;
        font-size: 0.25rem;
        font-weight: bold;
        text-wrap: nowrap;
        position: absolute;
        top: 40%;
        left: 0.8rem;
        transform: translate(0, -50%);
      }

      .balance {
        line-height: 40px;
        display: inline-block;
        font-size: 0.18rem;
        color: white;
        position: absolute;
        top: 70%;
        left: 0.8rem;
        transform: translate(0, -50%);
      }
    }

    .info {
      position: absolute;
      right: 0;
      top: 0;
      width: 180px;
      height: 80px;
      cursor: pointer;
      background-color: #f39b00;
      padding-left: 10px;
      box-sizing: border-box;

      img {
        height: 50px;
        border-radius: 50px;
        margin: 15px 8px 0 0;
      }

      .el-dropdown {
        height: 67px;
        position: absolute;
        top: 0;

        p {
          display: inline-block;
          width: 110px;
          height: 80px;
          vertical-align: top;
          margin: 0;

          span {
            word-break: normal;
            width: 90px;
            white-space: pre-wrap;
            word-wrap: break-word;
            overflow: hidden;
            display: block;
            color: white;
            font-size: 0.18rem;
            margin-top: 20px;
          }

          span:nth-child(2) {
            font-size: 0.15rem;
            margin-top: 3px;
          }

          i {
            position: absolute;
            top: 50%;
            right: 10%;
            color: white;
            font-size: 0.25rem;
          }
        }
      }
    }

    .tit {
      color: white;
      flex: 1;
      text-align: center;
      line-height: 60px;
      font-size: 0.4rem;
      font-weight: bold;
      font-family: "微软雅黑";
    }
  }

  .el-container {
    height: 100%;
  }

  .el-aside {
    background-color: #d3dce6;
    color: #333;
    text-align: center;
    line-height: 200px;

    .tac {
      height: 100%;

      .el-col-12 {
        width: 100%;
        height: 100%;

        .el-menu {
          height: 100%;
        }
      }
    }
  }

  .el-main {
    background-color: #e9eef3;
    color: #333;
    text-align: center;
    padding: 0;

    .router-view {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue